import { Icon } from "@iconify/react";
import { useMutation, useQueries, useQuery } from "@tanstack/react-query";
import PageLoader from "Components/PageLoader";
import CustomerTable from "Components/support/customervendor/customer";
import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  fetchAllCategories,
  fetchAllPurities,
  fetchAllStockReport,
  fetchAllStockReportByDesign,
  fetchAllStockReportByProduct,
  fetchAllStockReportBySKU,
  fetchAllVendors,
} from "services/generalService";
import Skeleton from "UIComp/Skeleton";
import { reportsByProduct, reportsBySKU } from "utils/helpers";
const defaultData = {
  category: "1",
  purity: "",
  product: "",
  design: "",
  vendor:"",
  sku:""
};
const SKU = ({
  allCategories,
  allPurities,
  allProducts,
  allDesigns,
  clientCode,
  style,
  allVendors,
  allSku
}) => {
  
  const {
    data: allStockReport,
    isError: allStockReportIsError,
    isPending: allStockReportIsLoading,
    mutate,
  } = useMutation({ mutationFn: fetchAllStockReportBySKU });

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: defaultData });

  
  const stockType = watch("stockType");
  const category = watch("category");
  const purity = watch("purity");
  const product = watch("product");
  const design = watch("design");
  const vendor = watch("vendor");
  const sku = watch("sku");

  const purityList = useMemo(() => {
    if (allPurities?.length && category) {
      const result = allPurities?.filter(
        (item) => item?.CategoryId == category
      );
      return result;
    }
  }, [allPurities, category]);

  const productList = useMemo(() => {
    if (allProducts?.length && category) {
      const result = allProducts?.filter(
        (item) => item?.CategoryId == category
      );
      return result;
    }
  }, [allProducts, category]);

  const designList = useMemo(() => {
    if (allDesigns?.length && category) {
      const result = allDesigns?.filter(
        (item) => item?.CategoryId == category && item?.ProductId == product
      );
      return result;
    }
  }, [allDesigns, category, product]);

  useEffect(() => {
    mutate({
      ClientCode: clientCode,
      CategoryId: +(category || 0),
      ProductId: +(product || 0),
      DesignId: +(design || 0),
      PurityId: +(purity || 0),
      VendorId:+(vendor || 0),
      StockKeepingUnit:sku
    });
  }, [
    // purity, stockType, design,vendor,sku
  ]);

  const skuReport = useMemo(()=>{
     if(allStockReport?.length){
      let result = allStockReport
      if(category){
        result = result?.filter((item)=>item?.CategoryId == category)
      }
      if(product){
        result = result?.filter((item)=>item?.ProductId == product)
      }
      if(design){
        result = result?.filter((item)=>item?.DesignId == design)
      }
      if(purity){
        result = result?.filter((item)=>item?.PurityId == purity)
      }
      if(purity){
        result = result?.filter((item)=>item?.PurityId == purity)
      }
      if(vendor){
        result = result?.filter((item)=>item?.VendorId == vendor)
      }
      if(sku){
        result = result?.filter((item)=>item?.SKUId == sku)
      }
      return result
     }
  },[allStockReport,category,product,design,purity,vendor,sku])

  const DownloadExcel = (data)=>{
    const headers = {
      'S.No': null, // Auto-generated
      'Category': 'Category',
      'Opening Qty': 'OpeningQuantity',
      'Opening Gr Wt': 'OpeningGrossWeight',
      'Opening Net Wt': 'OpeningNetWeight',
      'Stock In Qty': 'StockEntryQuantity',
      'Stock In Gr Wt': 'StockEntryGrWt',
      'Sale Qty': 'SaleQty',
      'Sale Gross Wt': 'SaleGrossWt',
      'Closing Qty': 'ClosingQty',
      'Closing Gr Wt': 'ClosingGrossWeight',
      'Closing Net Wt': 'ClosingNetWeight',
     
    };
    exportToExcel(data, headers, 'StockCategoryReport.xlsx');
  }

  return (
    <>
      <div style={{ margin: "20px 0px" }}>
        <div>
          <div className={style.filterBox}>
            {/* Stock Type */}
            <div className={style.inputContainer}>
              <label htmlFor="stockType" className={style.inputLabel}>
                Stock Type
              </label>
              <select
                className={style["input-selects"]}
                id="stockType"
                {...register("stockType")}
              >
                <option value="">Stock Type</option>
                <option value="Labelled Stock">Labelled</option>
                <option value="Unlabelled Stock">Unlabelled</option>
              </select>
            </div>

            {/* Category */}
            <div className={style.inputContainer}>
              <label htmlFor="category" className={style.inputLabel}>
                Category
              </label>
              <select
                className={style["input-selects"]}
                id="category"
                {...register("category")}
              >
                <option value="">Select Category</option>
                {allCategories?.length
                  ? allCategories?.map((x) => (
                      <option key={x.Id} value={`${x.Id}`}>
                        {x.CategoryName}
                      </option>
                    ))
                  : []}
              </select>
            </div>

            {/* Product */}
            <div className={style.inputContainer}>
              <label htmlFor="product" className={style.inputLabel}>
                Product
              </label>
              <select
                className={style["input-selects"]}
                id="product"
                {...register("product")}
              >
                <option value="">Select Product</option>
                {productList?.length
                  ? productList?.map((x) => (
                      <option key={x?.Id} value={`${x?.Id}`}>
                        {x?.ProductName}
                      </option>
                    ))
                  : []}
              </select>
            </div>

            {/* Design */}
            <div className={style.inputContainer}>
              <label htmlFor="design" className={style.inputLabel}>
                Design
              </label>
              <select
                className={style["input-selects"]}
                id="design"
                {...register("design")}
              >
                <option value="">-- select --</option>
                {designList?.length
                  ? designList?.map((x) => (
                      <option key={x?.Id} value={`${x?.Id}`}>
                        {x?.DesignName}
                      </option>
                    ))
                  : []}
              </select>
            </div>

            {/* Purity */}
            <div className={style.inputContainer}>
              <label htmlFor="purity" className={style.inputLabel}>
                Purity
              </label>
              <select
                className={style["input-selects"]}
                id="purity"
                {...register("purity")}
              >
                <option value="">-- select --</option>
                {purityList?.length
                  ? purityList?.map((x) => (
                      <option key={x?.Id} value={`${x?.Id}`}>
                        {x?.PurityName}
                      </option>
                    ))
                  : []}
              </select>
            </div>
            <div className={style.inputContainer}>
              <label htmlFor="purity" className={style.inputLabel}>
                Vendor
              </label>
              <select
                className={style["input-selects"]}
                id="purity"
                {...register("vendor")}
              >
                <option value="">-- select --</option>
                {allVendors?.length
                  ? allVendors?.map((x) => (
                      <option key={x?.Id} value={`${x?.Id}`}>
                        {x?.VendorName}
                      </option>
                    ))
                  : []}
              </select>
            </div>

            <div className={style.inputContainer}>
              <label htmlFor="purity" className={style.inputLabel}>
                SKU
              </label>
              <select
                className={style["input-selects"]}
                id="purity"
                {...register("sku")}
              >
                <option value="">-- select --</option>
                {allSku?.length
                  ? allSku?.map((x) => (
                      <option key={x?.Id} value={`${x?.Id}`}>
                        {x?.StockKeepingUnit}
                      </option>
                    ))
                  : []}
              </select>
            </div>

           

            {/* Reset Button */}
            <div className={style.buttonContainer}>
              <button
                className={style["two-buttons"]}
                style={{
                  backgroundColor: "#fff",
                  color: "#0077d4",
                  border: "1px solid #0077d4",
                  padding: "10px 10px",
                }}
                onClick={() => reset()}
              >
                <Icon icon="ix:reset" width="24" height="512" />
                Reset
              </button>

              {/* Print Button */}
              <button
                className={style["two-buttons"]}
                style={{
                  color: "#fff",
                  cursor: "pointer",
                  padding: "11px 10px",
                }}
                // onClick={() => printStockList()}
                onClick={() => DownloadExcel([...skuReport])}

              >
                <Icon icon="ic:outline-print" width="20" height="20" />
                Print List
              </button>
            </div>
          </div>
        </div>
      </div>
      {allStockReportIsLoading && !allStockReportIsError ? (
        <Skeleton />
      ) : (
        <CustomerTable
          columns={reportsBySKU}
          allCategories={skuReport?.length ? skuReport : []}
          searchInput={""}
          setSearchInput={() => {}}
          showActionButton={false}
        />
      )}
    </>
  );
};

export default SKU;
